import axios from 'axios';
import React, { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import './AdSliderPhone.css';
import icondelete from './img/icons/icons8-remove-100.png';
import iconadd from './img/icons/icons8-add-new-100.png';
import iconback from './img/icons/left-chevron.png';

function AdSliderPhone() {
  const [slidePhoneImg, setSlidePhoneImg] = useState([]);
  const [active, setActive] = useState(true);
  const [resp, setResp] = useState("");
  const [fileName, setFileName] = useState("Slide");
  const file = useRef();
  

  const uploader = async () => {

    setFileName('Slide');

    if(file.current.files.length === 0){
      setResp('Please choose an image');
    }else{

      const formData = new FormData();
      console.log(file);
      formData.append("picture", file.current.files[0]);
      formData.append("name", fileName);

      var xhr = new XMLHttpRequest();

      xhr.open('POST', 'https://toycityzimbabwe.com/backend/upload.php', true);

      xhr.onload = function(){
        setResp(this.responseText);

        setActive(!active);
        document.getElementById("appearadd").style.display = "none";

        axios
          .get('https://toycityzimbabwe.com/backend/getPhoneSlider.php')
          .then(res => {
            setSlidePhoneImg(res.data)
          })
          .catch( error => {
            console.log(error)
          });
      }

      xhr.send(formData);
    }
  };

  useEffect(() => {
    axios
    .get('https://toycityzimbabwe.com/backend/getPhoneSlider.php')
    .then(res => {
      setSlidePhoneImg(res.data)
    })
    .catch( error => {
      console.log(error)
    });
    
  }, [])

  const hadd = () => {
    setActive(!active);

    if(!active)
      document.getElementById("appearadd").style.display = "none";
    else
      document.getElementById("appearadd").style.display = "block";
  }

  const hdelete = (id) => {

    axios
        .get("https://toycityzimbabwe.com/backend/deletePhoneSlide.php", {params: { id }})
        .then(data => {
          console.log(data.data)
        })
        .catch(error => console.log(error));

    
    axios
        .get('https://toycityzimbabwe.com/backend/getPhoneSlider.php')
        .then(res => {
          setSlidePhoneImg(res.data)
        })
        .catch( error => {
          console.log(error)
        });
    
  }

  return (
    <div className='adsliderphone'>
      <h1>Slider Phone</h1>
      <button onClick={hadd}>
        {active ? <img src={iconadd} alt='iconadd' />
        : <img src={iconback} alt='iconadd' />}
      </button>
      <div id='appearadd' className='adsliderphone__upload'>
        <input type="file"  accept="image/*" ref={file} />
        <button onClick={uploader}>Upload</button>
      </div>
      <div className='adsliderphone__sms'>
        {resp}
      </div>
      <div className='adsliderphone__sliders'>
        {slidePhoneImg.map((obj) => (
          <div className='adsliderphone__slider'>
            <img src={obj.img} alt='slidePhoneImg' />
            <div>
              <button onClick={() => hdelete(obj.pslide_id)}> <img src={icondelete} alt='icondelete' /></button>
            </div>
          </div>
        ))}
      </div>      
    </div>
  )
}

export default AdSliderPhone;
